import Modal from "./modal";

export default class ShareModal extends Modal {
  constructor(companyId) {
    super("share-modal", companyId);

    this.companyId = companyId;
    this.$newEntrySelector = document.getElementById("new-entry-selector");
    this.hideNotifyCheckbox = false;

    this.setupListeners();

    Promise.all([
      this.loadDependencies(),
      this.setupStakeholders(),
      this.setupCollaborators(),
    ]).then(() => {
      this.setupForm();
      this.whenReady();
    });
  }

  loadDependencies() {
    return new Promise((resolve, reject) => {
      if (typeof Tagin !== "undefined") {
        resolve();
        return;
      }
      const styles = ["/css/dist/tagin.min.css"];
      const scripts = ["/js/dist/tagin.min.js"];

      styles.forEach((url) => {
        const el = document.createElement("link");
        el.rel = "stylesheet";
        el.type = "text/css";
        el.href = url;
        document.head.appendChild(el);
      });

      scripts.forEach((url) => {
        const el = document.createElement("script");
        el.type = "text/javascript";
        el.src = url;
        el.onload = () => {
          resolve();
        };
        document.head.appendChild(el);
      });
    });
  }

  setupStakeholders() {
    return peque
      .api("stakeholders", { company: this.companyId, detailed: true }, "get")
      .then((response) => {
        this.stakeholders = [];
        this.groups = [];

        response.result.list.forEach((stakeholder) => {
          stakeholder.fullName = stakeholder.fullName.replace(/,/g, "");
          this.stakeholders.push(stakeholder);

          if (!this.groups.includes(stakeholder.group)) {
            this.groups.push(stakeholder.group);
          }
        });

        return this.stakeholders;
      });
  }

  setupCollaborators() {
    if (this.type === peque.SHARE_TYPE_REPORT) {
      return;
    }
    return peque
      .api("collaborators", { company: this.companyId }, "get")
      .then((response) => {
        if (this.type === peque.SHARE_TYPE_REPORT) {
          return;
        }
        response.result.list.forEach((collaborator) => {
          this.addEntry(
            collaborator.id,
            collaborator.name,
            collaborator.email,
            false
          );
        });

        return response.result.list;
      });
  }

  hideNotify() {
    this.hideNotifyCheckbox = true;
  }

  setDetails(identifier, type, entity) {
    this.identifier = identifier;
    this.entity = entity;
    this.type = type;

    this.isSharingFolderOrDocument = [
      peque.SHARE_TYPE_FOLDER,
      peque.SHARE_TYPE_DOCUMENT,
    ].includes(type);

    if (this.isSharingFolderOrDocument && this.entity) {
      this.$copyLinkTypeSelector.value = this.entity.is_public
        ? "public"
        : "restricted";
      document
        .querySelector("[data-share-document-options]")
        .classList.remove("d-none");
      this.updateLinkInfo();
    }

    const $warning = document.getElementById("live-captable-warning");

    if (this.identifier === null) {
      $warning.classList.remove("d-none");
    } else {
      $warning.classList.add("d-none");
    }

    this.reset();

    peque
      .api(
        "share_permissions",
        {
          company: this.companyId,
          identifier: identifier,
          type: type,
        },
        "get"
      )
      .then((response) => {
        this.permissions = response.result;

        if (this.permissions) {
          this.permissions.forEach((entry) => {
            const viewsCount = entry.views ? entry.views.length : 0;
            this.addEntry(
              entry.guest.id,
              entry.guest.name,
              entry.guest.email,
              true,
              viewsCount
            );
          });
        }
      });
  }

  reset() {
    this.$form.querySelectorAll("[data-guest]").forEach((el) => {
      el.remove();
    });

    if (this.type === peque.SHARE_TYPE_REPORT) {
      this.$form.querySelectorAll("[data-collaborator]").forEach((el) => {
        el.remove();
      });
    }
  }

  showSharedWithContainer(show) {
    const $sharedWithContainer = document.getElementById(
      "shared-with-container"
    );

    if (show) {
      $sharedWithContainer.classList.remove("d-none");
    } else {
      $sharedWithContainer.classList.add("d-none");
    }
  }

  setupForm() {
    const $groupSelector = document.getElementById("stakeholders-group");
    this.groups.forEach((group) => {
      const option = document.createElement("option");
      option.value = group;
      option.innerText = group;
      $groupSelector.appendChild(option);
    });

    this.$tags = new Tagin(this.$newEntrySelector, {
      enter: true,
    });

    const list = [];
    this.stakeholders.forEach((stakeholder) => {
      list.push({
        label: stakeholder.fullName,
        value: stakeholder.id,
      });
    });

    const ac = new Autocomplete(this.$tags.input, {
      data: list,
      maximumItems: 5,
      highlightClass: "text-primary pe-none",
      dropdownOptions: {
        autoClose: false,
      },
      onSelectItem: ({ label, value }) => {
        const tags = this.$tags.getTags();
        const latestTag = tags[tags.length - 1];

        this.removeTag(latestTag);
        this.$tags.addTag(label);
      },
    });

    ac.dropdown._element.addEventListener("hide.bs.dropdown", () => {
      const tags = this.$tags.getTags();
      // he's still typing
      if (tags.length === 0 || this.$tags.input.value.length > 0) {
        return;
      }
      const latestTag = tags[tags.length - 1];

      if (latestTag.includes("@")) {
        return;
      }

      const stakeholdersByName = this.getStakeholdersByName();

      if (typeof stakeholdersByName[latestTag] === "undefined") {
        this.removeTag(latestTag);
      }
    });
  }

  setupListeners() {
    const $notifyPeopleContainer = document.getElementById(
      "notify-people-container"
    );

    this.$newEntrySelector.addEventListener("change", () => {
      if (this.hideNotifyCheckbox) {
        return;
      }
      const tags = this.$tags.getTags();

      if (tags.length > 0) {
        $notifyPeopleContainer.classList.remove("d-none");
      } else {
        $notifyPeopleContainer.classList.add("d-none");
      }
    });

    const $groupSelector = document.getElementById("stakeholders-group");

    $groupSelector.addEventListener("change", () => {
      if ($groupSelector.value.length === 0) {
        return;
      }
      const selectedGroup = $groupSelector.value;

      this.stakeholders.forEach((stakeholder) => {
        if (stakeholder.group === selectedGroup || selectedGroup === "all") {
          this.$tags.addTag(stakeholder.fullName);
        }
      });
    });

    this.$copyLinkBtn = document.querySelector("[data-copy-link]");

    this.$copyLinkTypeSelector = document.getElementById("copy-link-type");
    if (this.$copyLinkTypeSelector) {
      this.$copyLinkTypeSelector.addEventListener("change", (e) => {
        const isPublic = e.target.value === "public";
        this.setPublic(isPublic);
        this.entity.is_public = isPublic;
        this.updateLinkInfo();
      });

      this.$copyLinkBtn.addEventListener("click", () => {
        this.copyToClipboard(
          this.$copyLinkTypeSelector.value === "public"
            ? this.entity.publicLink
            : this.entity.link
        );
      });
    }
  }

  updateLinkInfo() {
    document.querySelector("[data-link-type-info]").innerText = this.entity
      .is_public
      ? trans("anyone_who_has_the_link_can_see_it")
      : trans("only_people_with_access_can_open_the_link");
  }

  removeTag(tag) {
    // make sure it doesn't end in comma, so no empty tag is added
    let text = this.$newEntrySelector.value.replace(tag, "").trim();

    text = text.replace(",,", ","); // remove any empty tags

    if (text.substr(-1) === ",") {
      text = text.substr(0, text.length - 1);
    }

    this.$newEntrySelector.value = text;
    this.$newEntrySelector.dispatchEvent(new Event("change"));
  }

  shareWith(name, value) {
    return new Promise((resolve, reject) => {
      let data = {
        company: this.companyId,
        identifier: this.identifier,
        type: this.type,
        notify: this.wantsEmailNotification(),
      };

      if (isNaN(value)) {
        data.email = value;
      } else {
        data.stakeholder = value;
      }

      peque
        .api("share_permissions", data, "post")
        .then((response) => {
          this.removeTag(name);
          this.addEntry(response.result.id, "", name);
          resolve();
        })
        .catch((error) => {
          if (error.error === peque.ERROR_INVALID_DATA) {
            let message;

            if (typeof data.stakeholder !== "undefined") {
              message = trans(
                "stakeholdername_does_not_have_an_email_set_do_you_want_to_add_it_now",
                {
                  stakeholderName: name,
                }
              );
              peque.navigation
                .showConfirm(message, trans("warning"))
                .then((answer) => {
                  if (!answer.isConfirmed) {
                    reject();
                    return;
                  }
                  this.showStakeholderModal(name, data.stakeholder, resolve);
                });
              return;
            } else if (typeof data.email !== "undefined") {
              message = trans("email_is_not_a_valid_email", {
                email: name,
              });
            }

            peque.navigation.showError(message);
          } else {
            peque.navigation.showError("Error with " + name);
          }
          reject();
        });
    });
  }

  setPublic(isPublic) {
    return new Promise((resolve, reject) => {
      let data = {
        is_public: isPublic,
      };
      const url =
        this.type === peque.SHARE_TYPE_DOCUMENT
          ? `documents/${this.identifier}`
          : `folders/${this.identifier}`;
      peque
        .api(url, data, "post")
        .then(() => {
          resolve();
        })
        .catch(() => {
          peque.navigation.showError();
          reject();
        });
    });
  }

  showStakeholderModal(name, stakeholderId, resolve) {
    let selectedStakeholder;
    this.stakeholders.forEach((stakeholder) => {
      if (stakeholder.id === stakeholderId) {
        selectedStakeholder = stakeholder;
      }
    });

    // since this modal is also used by send test modal, can't set the callback after new StakeholderModal(),
    // as it may already be defined
    if (typeof peque.stakeholderModal === "undefined") {
      peque.stakeholderModal = new StakeholderModal();
    }
    if (typeof this.stakeholderHideSet === "undefined") {
      peque.stakeholderModal.$modal._element.addEventListener(
        "hide.bs.modal",
        (event) => {
          this.enableSubmitButton(true);
        }
      );
      this.stakeholderHideSet = true;
    }
    peque.stakeholderModal.setCallback(() => {
      peque.stakeholderModal.hide();
      this.enableSubmitButton(false);
      this.shareWith(name, stakeholderId).then(resolve);
    });
    peque.stakeholderModal.setPrefillData(selectedStakeholder);
    peque.stakeholderModal.show();
  }

  wantsEmailNotification() {
    return document.getElementById("notify-people").checked;
  }

  addEntry(id, name, email, canBeDeleted, views) {
    if (typeof canBeDeleted === "undefined") {
      canBeDeleted = true;
    }
    if (typeof views === "undefined") {
      views = 0;
    }

    const $entry = peque.parseTemplate("shared-entry", {
      id,
      name,
      email,
      canBeDeleted,
      views,
    });

    $entry
      .querySelector('[data-action="delete"]')
      ?.addEventListener("click", () => {
        peque.navigation.showConfirm("").then((answer) => {
          if (!answer.isConfirmed) {
            return;
          }

          this.delete(id, $entry);
        });
      });

    const $ul = this.$form.querySelector("ul");

    if (canBeDeleted) {
      $ul.prepend($entry);
    } else {
      $ul.append($entry);
    }

    this.showSharedWithContainer(true);
  }

  delete(id, $entry) {
    peque
      .api("share_permissions/" + id, {}, "delete")
      .then((response) => {
        $entry.remove();
      })
      .catch((error) => {});
  }

  getStakeholdersByName() {
    const stakeholdersByName = {};

    this.stakeholders.forEach((stakeholder) => {
      stakeholdersByName[stakeholder.fullName] = stakeholder;
    });
    return stakeholdersByName;
  }

  async validateAndSendForm() {
    const onConfirm = () => {
      this.enableSubmitButton(false);

      const stakeholdersByName = this.getStakeholdersByName();

      // run each share sequentially as user may have to interact in some cases (like adding an email to an existing investor)
      const funcs = [];
      this.$tags.getTags().forEach((tag) => {
        funcs.push(() => {
          if (tag.includes("@")) {
            return this.shareWith(tag, tag);
          } else if (typeof stakeholdersByName[tag] !== "undefined") {
            return this.shareWith(tag, stakeholdersByName[tag].id);
          } else {
            // invalid entry, he wrote something random like ekrhruey
            peque.navigation.showError(tag + "??");
            throw "stop";
          }
        });
      });
      funcs.push(() => {
        this.enableSubmitButton(true);
        if (this.type === peque.SHARE_TYPE_REPORT) {
          location.href = peque.routeFor("showReportStats", {
            id: this.identifier,
          });
        }
      });

      funcs.reduce((prev, cur) => {
        return prev.then(cur).catch((error) => {
          this.enableSubmitButton(true);
        });
      }, Promise.resolve());
    };

    if (this.type === peque.SHARE_TYPE_REPORT) {
      peque.navigation
        .showConfirm(
          trans("the_update_will_be_sent_to_them_via_email_right_now")
        )
        .then((answer) => {
          if (!answer.isConfirmed) {
            return;
          }
          onConfirm();
        });
    } else {
      onConfirm();
    }
  }

  async copyToClipboard(text) {
    await navigator.clipboard.writeText(text);
  }
}
